import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: LIGHT_GREY,
    padding: theme.spacing(1, 0),
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
  },
  image: {
    borderRadius: 4,
    width: theme.spacing(22),
    height: theme.spacing(22),
    objectFit: "contain",
  },
  contentBtnVideo: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(29, 29, 29, .5)",
    borderRadius: 4,
    color: "#FFF",
    width: theme.spacing(22),
    height: theme.spacing(22),
  },
}));
